import classnames from 'classnames';
import React from 'react';

import useDetectKeyboard from '../../../hooks/useDetectKeyboard';
import getSafeAreaInsets from '../../../utils/native/getSafeAreaInsets';
import { isIOS } from '../../../utils/native/platform';
import { KeyboardPadding } from '../../KeyboardPadding';
import StickyFooter from './StickyFooter';

import './StickyFooterRow.scss';

interface Props extends React.PropsWithChildren {
    onlyShowWithKeyboard?: boolean;
    className?: string;
}

const StickyFooterRow: React.FC<Props> = ({ children, onlyShowWithKeyboard, className }) => {
    const { isKeyboardVisible } = useDetectKeyboard();
    const hasBottomInsetOnIOS = isIOS() && getSafeAreaInsets().bottom > 0;

    return (
        <>
            <StickyFooter
                className={classnames(
                    'sticky-footer-row__container',
                    { 'sticky-footer-row__safe-area-inset-override': hasBottomInsetOnIOS },
                    className,
                )}
                onlyShowWithKeyboard={onlyShowWithKeyboard}
                keyboardVisible={isKeyboardVisible}
            >
                {children}
            </StickyFooter>
            {(!onlyShowWithKeyboard || isKeyboardVisible) && (
                <div className={classnames('sticky-footer-row__spaceholder', { 'with-inset': hasBottomInsetOnIOS })} />
            )}
            {isKeyboardVisible && <KeyboardPadding />}
        </>
    );
};

export default StickyFooterRow;
